import { Images } from "../../../Images";
import BigNum from "../../math/BigNum";
import Values from "../../value/Values";
import RubyBonusSkillNode from "./RubyBonusSkillNode";
import { SkillIds } from "../SkillIds";
import SkillType from "../SkillType";

export default class RubyBonusSkill extends SkillType {
    /**
     * @param {Totals} totals
     * @param {Values} values
     * @param {MineDamageLogic} mineDamageLogic
     */
    constructor(totals, values, mineDamageLogic) {
        super(SkillIds.RUBY_BONUS);

        /**
         * @constant
         * @type {Values}
         */
        this.values = values;

        const inc = 50;
        let cost = 200;
        let purchaseIndex = 0;

        const rubyBonus1 = this.addNode(new RubyBonusSkillNode('rubyBonus1', 
            totals, Images.currency.ruby, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const rubyBonus2 = this.addNode(new RubyBonusSkillNode('rubyBonus2', 
            totals, Images.currency.ruby, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const rubyBonus3 = this.addNode(new RubyBonusSkillNode('rubyBonus3', 
            totals, Images.currency.ruby, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const rubyBonus4 = this.addNode(new RubyBonusSkillNode('rubyBonus4', 
            totals, Images.currency.ruby, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const rubyBonus5 = this.addNode(new RubyBonusSkillNode('rubyBonus5', 
            totals, Images.currency.ruby, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const rubyBonus6 = this.addNode(new RubyBonusSkillNode('rubyBonus6', 
            totals, Images.currency.ruby, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const rubyBonus7 = this.addNode(new RubyBonusSkillNode('rubyBonus7', 
            totals, Images.currency.ruby, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const rubyBonus8 = this.addNode(new RubyBonusSkillNode('rubyBonus8', 
            totals, Images.currency.ruby, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const rubyBonus9 = this.addNode(new RubyBonusSkillNode('rubyBonus9', 
            totals, Images.currency.ruby, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const rubyBonus10 = this.addNode(new RubyBonusSkillNode('rubyBonus10', 
            totals, Images.currency.ruby, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const rubyBonus11 = this.addNode(new RubyBonusSkillNode('rubyBonus11', 
            totals, Images.currency.ruby, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const rubyBonus12 = this.addNode(new RubyBonusSkillNode('rubyBonus12', 
            totals, Images.currency.ruby, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const rubyBonus13 = this.addNode(new RubyBonusSkillNode('rubyBonus13', 
            totals, Images.currency.ruby, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const rubyBonus14 = this.addNode(new RubyBonusSkillNode('rubyBonus14', 
            totals, Images.currency.ruby, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const rubyBonus15 = this.addNode(new RubyBonusSkillNode('rubyBonus15', 
            totals, Images.currency.ruby, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const rubyBonus16 = this.addNode(new RubyBonusSkillNode('rubyBonus16', 
            totals, Images.currency.ruby, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const rubyBonus17 = this.addNode(new RubyBonusSkillNode('rubyBonus17', 
            totals, Images.currency.ruby, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const rubyBonus18 = this.addNode(new RubyBonusSkillNode('rubyBonus18', 
            totals, Images.currency.ruby, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const rubyBonus19 = this.addNode(new RubyBonusSkillNode('rubyBonus19', 
            totals, Images.currency.ruby, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const rubyBonus20 = this.addNode(new RubyBonusSkillNode('rubyBonus20', 
            totals, Images.currency.ruby, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));

        cost += inc;
        purchaseIndex++;

        const rubyBonus21 = this.addNode(new RubyBonusSkillNode('rubyBonus21', 
            totals, Images.currency.ruby, new BigNum(cost), this, this.values, mineDamageLogic, purchaseIndex
        ));
        


        rubyBonus1.addChildNode(rubyBonus2);
        rubyBonus2.addChildNode(rubyBonus3);
        rubyBonus3.addChildNode(rubyBonus4);
        rubyBonus4.addChildNode(rubyBonus5);
        rubyBonus5.addChildNode(rubyBonus6);
        rubyBonus6.addChildNode(rubyBonus7);
        rubyBonus7.addChildNode(rubyBonus8);

        rubyBonus8.addChildNode(rubyBonus9);
        rubyBonus9.addChildNode(rubyBonus10);
        rubyBonus10.addChildNode(rubyBonus11);
        rubyBonus11.addChildNode(rubyBonus12);
        rubyBonus12.addChildNode(rubyBonus13);
        rubyBonus13.addChildNode(rubyBonus14);
        rubyBonus14.addChildNode(rubyBonus15);

        rubyBonus15.addChildNode(rubyBonus16);
        rubyBonus16.addChildNode(rubyBonus17);
        rubyBonus17.addChildNode(rubyBonus18);
        rubyBonus18.addChildNode(rubyBonus19);
        rubyBonus19.addChildNode(rubyBonus20);
        rubyBonus20.addChildNode(rubyBonus21);

        ///////////////////////////////////
        // Position the nodes in the graph
        ///////////////////////////////////

        // Starting coordinate of the skill
        const startX = -1;
        const startY = -12;

        rubyBonus1.setPosition(startX, startY);
        rubyBonus2.setPosition(startX - 1, startY);
        rubyBonus3.setPosition(startX - 2, startY);
        rubyBonus4.setPosition(startX - 3, startY);
        rubyBonus5.setPosition(startX - 4, startY);
        rubyBonus6.setPosition(startX - 5, startY);
        rubyBonus7.setPosition(startX - 6, startY);

        rubyBonus8.setPosition(startX - 6, startY - 1);
        rubyBonus9.setPosition(startX - 5, startY - 1);
        rubyBonus10.setPosition(startX - 4, startY - 1);
        rubyBonus11.setPosition(startX - 3, startY - 1);
        rubyBonus12.setPosition(startX - 2, startY - 1);
        rubyBonus13.setPosition(startX - 1, startY - 1);
        rubyBonus14.setPosition(startX, startY - 1);

        rubyBonus15.setPosition(startX, startY - 2);
        rubyBonus16.setPosition(startX - 1, startY - 2);
        rubyBonus17.setPosition(startX - 2, startY - 2);
        rubyBonus18.setPosition(startX - 3, startY - 2);
        rubyBonus19.setPosition(startX - 4, startY - 2);
        rubyBonus20.setPosition(startX - 5, startY - 2);
        rubyBonus21.setPosition(startX - 6, startY - 2);

    }
    
}